"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation updateOrganizationFee($orgId: String!, $fee: FeeInput!) {
    updateOrganizationFee(orgId: $orgId, fee: $fee) {
      _id
      name
      orgId
      eventId
      type
      value
      appliedTo
      appliedBy
      minAppliedToPrice
      maxAppliedToPrice
      filters
      createdBy
      createdAt
      updatedBy
      updatedAt
      disabled
      paymentMethods
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=updateOrganizationFee.mutation.js.map